var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccordion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69px",
    height: "51px",
    viewBox: "0 0 69 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 21") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project-Editor-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#4A4A4A",
    strokeWidth: 3,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 65.3913043,
    height: 15.6666667
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4A4A4A",
    fillRule: "nonzero",
    points: "52.4492754 6.47737198 53.493067 5.44927536 56.8782874 8.8419942 60.2605562 5.44927536 61.3043478 6.47737198 56.8782874 10.8985507"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4A4A4A",
    x: 5.44927536,
    y: 6.13043478,
    width: 24.5217391,
    height: 4.08695652
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-17",
    stroke: "#4A4A4A",
    strokeWidth: 3,
    fill: "#FFFFFF",
    x: 0,
    y: 15.6666667,
    width: 65.3913043,
    height: 15.6666667
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy-10",
    fill: "#4A4A4A",
    fillRule: "nonzero",
    points: "52.4492754 22.1440386 53.493067 21.115942 56.8782874 24.5086609 60.2605562 21.115942 61.3043478 22.1440386 56.8782874 26.5652174"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    fill: "#4A4A4A",
    x: 5.44927536,
    y: 21.7971014,
    width: 24.5217391,
    height: 4.08695652
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    stroke: "#4A4A4A",
    strokeWidth: 3,
    fill: "#FFFFFF",
    x: 0,
    y: 15.6666667,
    width: 65.3913043,
    height: 15.6666667
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy-11",
    fill: "#4A4A4A",
    fillRule: "nonzero",
    points: "52.4492754 22.1440386 53.493067 21.115942 56.8782874 24.5086609 60.2605562 21.115942 61.3043478 22.1440386 56.8782874 26.5652174"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-18",
    fill: "#4A4A4A",
    x: 5.44927536,
    y: 21.7971014,
    width: 24.5217391,
    height: 4.08695652
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-21",
    stroke: "#4A4A4A",
    strokeWidth: 3,
    fill: "#FFFFFF",
    x: 0,
    y: 31.3333333,
    width: 65.3913043,
    height: 15.6666667
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy-12",
    fill: "#4A4A4A",
    fillRule: "nonzero",
    points: "52.4492754 37.8107053 53.493067 36.7826087 56.8782874 40.1753275 60.2605562 36.7826087 61.3043478 37.8107053 56.8782874 42.2318841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-20",
    fill: "#4A4A4A",
    x: 5.44927536,
    y: 37.4637681,
    width: 24.5217391,
    height: 4.08695652
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordion);
export default __webpack_public_path__ + "static/media/Accordion.edb76562.svg";
export { ForwardRef as ReactComponent };